import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type AuthPanelState = { open: boolean; returnTo: string | null };
export type AuthPanelRootState = { authPanel: AuthPanelState };

const initialState: AuthPanelState = { open: false, returnTo: null };
const slice = createSlice({
  name: 'authPanel',
  initialState,
  reducers: {
    opened(state, action: PayloadAction<string | null>) {
      state.open = true;
      state.returnTo = action.payload;
    },
    closed(state) {
      state.open = false;
      state.returnTo = null;
    },
  },
});

export const authPanelReducer = slice.reducer;
export const authPanelActions = slice.actions;
